// Configuração central para requisições à API Social Carbon / registro (Wilder/Bubble).
// Produção (sem sandbox Bubble): https://registry.socialcarbon.org/api/1.1
// Alternativa documentada no projeto: https://wilder.earth/api/1.1 (não usar .../version-test/... em produção).
// REACT_APP_WILDER_URL no build (ex.: Amplify WILDER_URL_MAIN) sobrescreve este default.
const DEFAULT_BASE_URL = 'https://registry.socialcarbon.org/api/1.1';

// Configuração central para requisições à API Wilder
export const WILDER_CONFIG = {
  // URL base (ex.: https://registry.socialcarbon.org ou https://registry.socialcarbon.org/api/1.1)
  BASE_URL: (process.env.REACT_APP_WILDER_URL || DEFAULT_BASE_URL).replace(/\/$/, ''),
  
  // Endpoints disponíveis
  ENDPOINTS: {
    ASSETS: '/obj/asset',
    RETIREMENTS: '/obj/retirement/',
  },
  
  // Configurações de requisição
  REQUEST_CONFIG: {
    timeout: 30000, // 30 segundos
    headers: {
      'Content-Type': 'application/json',
    },
  },
  
  // Configurações de cache (opcional para futuras implementações)
  CACHE: {
    enabled: false,
    ttl: 5 * 60 * 1000, // 5 minutos
  },
};

// Função utilitária para construir URLs completas
export const buildWilderUrl = (endpoint) => {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${WILDER_CONFIG.BASE_URL}${path}`;
};

export const RETIREMENT_DETAILS_BASE_URL =
  'https://registry.socialcarbon.org/retirement_details';

export const WILDER_TX_SEARCH_URL =
  'https://blockexplorer.wilder.earth/transaction_search';

export const buildRetirementDetailsUrl = (retirementId) => {
  if (!retirementId) return null;
  return `${RETIREMENT_DETAILS_BASE_URL}/${retirementId}`;
};

// Função utilitária para tratamento de erros padrão
export const handleWilderError = (error, context = '') => {
  console.error(`Erro na requisição Wilder (${context}):`, error);
  
  if (error.response) {
    // Erro de resposta do servidor
    return `Erro do servidor: ${error.response.status} - ${error.response.statusText}`;
  } else if (error.request) {
    // Erro de rede
    return 'Erro de conexão com o servidor Wilder';
  } else {
    // Erro geral
    return error.message || 'Erro desconhecido na requisição';
  }
};
